<div class="row grad py-1">
    <div class ="col-sm-12 col-md-6 col-lg-3 text-center">
        <div class="card card-main text-center">
           <img class="card-img-top" src="assets/images/cards/design_1_card.png" alt="How to use technology in learning mathematics">
        </div>
    </div>
    <div class ="col-sm-12 col-md-6 col-lg-3 text-center">
        <div class="card card-main text-center">
            <img class="card-img-top" src="assets/images/cards/design_2_card.png" alt="Card image cap">
        </div>
    </div>
    <div class ="col-sm-12 col-md-6 col-lg-3 text-center">
        <div class="card card-main text-center">
            <img class="card-img-top" src="assets/images/cards/design_3_card.png" alt="How to use technology in learning mathematics">
        </div>
    </div>
    <div class ="col-sm-12 col-md-6 col-lg-3 text-center">
        <div class="card card-main text-center">
            <img class="card-img-top" src="assets/images/cards/design_4_card.png" alt="Card image cap">
            
        </div>
    </div>
    </div>
